import script from "./sidebar-edit-profile-picture.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-edit-profile-picture.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar-edit-profile-picture.vue?vue&type=style&index=0&id=5f1a43fa&lang=css"

const __exports__ = script;

export default __exports__